import React from 'react'
import { Profile } from '../../types/profile'
import { Alert, Stack, Typography } from '@mui/material'
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { useTranslation } from 'react-i18next'

export interface ProfileBulkOpFeedbackProps {
  onClose: () => void
  assignedProfiles?: Profile[]
  unassignedProfiles?: Profile[]
  assignedBbp?: Profile
  unassignedBbp?: Profile
  error?: string
}
enum AlertType {
  assigned = 1,
  unassigned = 2,
  replaced = 3,
  error = 4,
}
const ProfileBulkOpFeedback = (props: ProfileBulkOpFeedbackProps) => {
  const { t } = useTranslation()
  const [alertType, setAlertType] = React.useState<AlertType>()
  const [showAlert, setShowAlert] = React.useState<boolean>(false)
  const timeoutRef = React.useRef<any>()

  React.useEffect(() => {
    let i = 0
    if (
      (props.assignedProfiles?.length || props.assignedBbp) &&
      (props.unassignedProfiles?.length || props.unassignedBbp)
    ) {
      i = 3
    } else if (props.assignedProfiles?.length || props.assignedBbp) {
      i = 1
    } else if (props.unassignedProfiles?.length || props.unassignedBbp) {
      i = 2
    } else if (props.error) {
      i = 4
    }
    setAlertType(i)
    setShowAlert(true)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      setShowAlert(false)
    }, 15000 + (timeoutRef.current ? 15000 : 0))
  }, [
    props.assignedBbp,
    props.assignedProfiles,
    props.assignedProfiles?.length,
    props.error,
    props.unassignedBbp,
    props.unassignedProfiles,
    props.unassignedProfiles?.length,
  ])

  const assignedProfiles = props.assignedProfiles?.map((p) => p.name).join(', ')
  const unassignedProfiles = props.unassignedProfiles?.map((p) => p.name).join(', ')

  return (
    <>
      {showAlert && (
        <Stack sx={{ width: '100%' }}>
          {alertType === AlertType.assigned && (
            <Alert icon={<FileUploadIcon />} sx={{ alignItems: 'center' }} onClose={props.onClose}>
              <Stack direction={'row'}>
                <Typography>{t('profilesview.assigned')}</Typography>
                {assignedProfiles && (
                  <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                    {t('profilesview.profileslist').replace('{0}', assignedProfiles)}
                  </Typography>
                )}
                {props.assignedBbp && (
                  <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                    {t('profilesview.bbplist').replace('{0}', props.assignedBbp.name)}
                  </Typography>
                )}
              </Stack>
            </Alert>
          )}
          {alertType === AlertType.unassigned && (
            <Alert icon={<FileUploadIcon sx={{ transform: 'rotate(180deg)' }} />} onClose={props.onClose}>
              <Stack direction={'row'}>
                <Typography>{t('profilesview.unassigned')}</Typography>
                {unassignedProfiles && (
                  <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                    {t('profilesview.profileslist').replace('{0}', unassignedProfiles)}
                  </Typography>
                )}
                {props.unassignedBbp && (
                  <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                    {t('profilesview.bbplist').replace('{0}', props.unassignedBbp.name)}
                  </Typography>
                )}
              </Stack>
            </Alert>
          )}
          {alertType === AlertType.replaced && (
            <Alert
              icon={<PublishedWithChangesIcon />}
              color="warning"
              sx={{ alignItems: 'center' }}
              onClose={props.onClose}
            >
              <Stack direction={'row'} sx={{ alignItems: 'center' }}>
                <Typography>{t('common.replaced')}</Typography>
                <Stack direction={'column'} sx={{ ml: 5 }}>
                  <Stack direction={'row'}>
                    <Typography variant="subtitle2">{t('profilesview.assigned')}</Typography>
                    {assignedProfiles && (
                      <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                        {t('profilesview.profileslist').replace('{0}', assignedProfiles)}
                      </Typography>
                    )}
                    {props.assignedBbp && (
                      <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                        {t('profilesview.bbplist').replace('{0}', props.assignedBbp.name)}
                      </Typography>
                    )}
                  </Stack>
                  <Stack direction={'row'}>
                    <Typography variant="subtitle2">{t('profilesview.unassigned')}</Typography>
                    {unassignedProfiles && (
                      <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                        {t('profilesview.profileslist').replace('{0}', unassignedProfiles)}
                      </Typography>
                    )}
                    {props.unassignedBbp && (
                      <Typography sx={{ ml: 2.5 }} variant="subtitle2">
                        {t('profilesview.bbplist').replace('{0}', props.unassignedBbp.name)}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </Alert>
          )}
          {alertType === AlertType.error && (
            <Alert severity="error" onClose={props.onClose}>
              <Typography variant="subtitle2">{props.error}</Typography>
            </Alert>
          )}
        </Stack>
      )}
    </>
  )
}
export default ProfileBulkOpFeedback
